import React, {useContext} from 'react';
import styled from "styled-components";
import {Navbar, Dropdown, Icon} from "react-materialize";
import MainNavItems from "./NavItems/MainNavItems.react";
import SideNavItems from "./NavItems/SideNavItems.react";
import AppContext from "../../Context/AppContext.react";

const StyledNav = styled.div`
  position: fixed;
  z-index: 100;
  left: 0;
  right: 0;
  top: 0;
  nav {
    background-color: #FFFFFF;
    color: #6C6C6C;
  }
    
  a { color: #6C6C6C; }
`

const TBNavbar = ({userName = "User"}) => {
  const {permissions} = useContext(AppContext);
  return (
    <StyledNav>
      <Navbar
        alignLinks="right"
        brand={<MainNavItems permissions={permissions} />}
        id="mobile-nav"
        menuIcon={<Icon>menu</Icon>}
        options={{
          draggable: true,
          edge: 'left',
          inDuration: 250,
          onCloseEnd: null,
          onCloseStart: null,
          onOpenEnd: null,
          onOpenStart: null,
          outDuration: 200,
          preventScrolling: true
        }}
      >
        <SideNavItems permissions={permissions} userName={userName} />
      </Navbar>
    </StyledNav>
  )
}

export default TBNavbar;